import React from 'react'
import { styled, Typography } from '@mui/material'
import { formatName } from '@edge/spark/utils'
import { EditDashboardNameButton } from '../EditDashboardNameButton'
import type { UserAttributes } from '@edge/spark/io-roles'

interface Props {
    user?: UserAttributes
    name: string
}

const HiddenEditDashboardNameButton = styled(EditDashboardNameButton)`
    margin-left: 8px;
    opacity: 0.1;
    &:hover {
        opacity: 1;
    }
    transition: opacity 0.5s ease-in-out;
`

const BoldInlineHeading = styled(Typography)`
    font-weight: 600;
    &:hover {
        & > button {
            opacity: 1;
        }
    }
`

export const DashboardHeading: React.FC<Props> = ({ name, user }: Props) => {
    const formattedName = formatName(user)

    return (
        <BoldInlineHeading display="inline" variant="h4">
            {formattedName ? `${formattedName}: ` : ''}
            {name}
            <HiddenEditDashboardNameButton sx={{ m: 1 }} initialValue={name} />
        </BoldInlineHeading>
    )
}

export default DashboardHeading
